"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationProvider = TranslationProvider;
const React = __importStar(require("react"));
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const LanguageTexts = __importStar(require("@genesys/shared/lib/language-texts"));
const UserProfile = __importStar(require("../user-profile"));
const Contexts = __importStar(require("../contexts"));
const GraphQLQuery = __importStar(require("../graphql-query"));
const query = (0, graphql_tag_1.default) `
  query TranslationQuery($language: String!) {
    product {
      language(languageCode: $language) {
        id
        texts
      }
    }
  }
`;
class TranslationProviderInternal extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            language: props.language,
            translate: (textDefinition) => LanguageTexts.translate(props.texts, textDefinition, false, false)
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.language !== prevState.language) {
            return {
                language: nextProps.language,
                translate: (textDefinition) => LanguageTexts.translate(nextProps.texts, textDefinition, false, false)
            };
        }
        return null;
    }
    render() {
        return (React.createElement(Contexts.TranslateContext.Provider, { value: this.state.translate }, React.Children.only(this.props.children)));
    }
}
function TranslationProvider({ children }) {
    return (React.createElement(UserProfile.UserProfile, null, ({ language: languageId }) => {
        if (languageId === "lngcod") {
            return (React.createElement(TranslationProviderInternal, { language: languageId, texts: {}, children: children }));
        }
        return (React.createElement(GraphQLQuery.QueryProductSimple, { query: query, variables: {
                language: languageId || "en-GB" // fallback
            } }, ({ product: { language } }) => (React.createElement(TranslationProviderInternal, { language: language.id, texts: language.texts, children: children }))));
    }));
}
//# sourceMappingURL=translation-provider.js.map